import { useFormik } from "formik"
import Chip from "global/Chip/Chip"
import CustomPersonalizeForm from "global/CustomSwitchInput/CustomPersonalizeForm"
import { useFetchHub } from "global/hooks/useFetchOptions"
import { paginationType } from "global/Interfaces/Interfaces"
import SimpleButton from "global/SimpleButton/SimpleButton"
import { FC, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setFishFilter } from "redux/fish-manamgement"
import { filterOrderInternal } from "redux/order-internal"
import { OrderInitialFilterElements } from "./OrderInitialFilter"


const FishSearchForm: FC<{}> = () => {
  const [chipData, setChipData] = useState("")
  const { pageNumbers } = useSelector((state: paginationType) => state.paginate)
  const { options: hubOptions } = useFetchHub()
  const { options:destinationHubOptions} = useFetchHub(false,false,false)
  const [filterData, setFilterData] = useState({})
  const dispatch = useDispatch()
  const userInfo = useSelector((state: any) => state.userInfo)

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      senderHub: { id: userInfo.currenthub?.id ,text:userInfo.currenthub?.label},
      receiverHub: null,
      trackingNumber: "",
    },
    onSubmit: async (values: any) => {
      console.log(values)
      const finalData = {
        ...values,
      }
      setFilterData(finalData)
      setChipData({ ...finalData, senderHub: undefined })
    },
  })

  const { values, handleSubmit }: any = formik

  useEffect(() => {
    const finalData = {
      ...values,
    }
    dispatch(setFishFilter({ ...finalData }))
    dispatch(
      filterOrderInternal({
        ...finalData,
        pageSize: 10,
        pageNumber: pageNumbers,
      }) as any
    )
    return () => {
      // dispatch(clearCreditSettlement());
    }
  }, [filterData, pageNumbers, dispatch])
  


  return (
    <>
      <form onSubmit={handleSubmit} className="searchForm ">
        {/* <InputTreeSelect
          selectedNodes={selectedNodes}
          setSelectedNodes={setSelectedNodes}
          type="select"
          singleSelect
          wrapperClassName="filterInput"
          initialValue={selectedNodes[0]?.label || userInfo.currenthub?.label}
          onSelect={(value) => {
            console.log(value)
            setSelectedNodes(value)
            formik.setFieldValue("senderHub", { id: value[0]?.id ,text:value[0]?.label})
          }}
        /> */}
        {OrderInitialFilterElements.filter((item) => item.isMain).map(
          (item: any, index: number) => {
            return (
              <CustomPersonalizeForm
                key={index}
                element={item}
                formik={formik}
                selectOptions={{
                  hubOptions,
                  destinationHubOptions
                }}
                // fetchInputOnchange={fetchInputOnchange}
              />
            )
          }
        )}
        <SimpleButton searchBtn />
      </form>
      {filterData && <Chip filterData={chipData} formData={formik} />}
    </>
  )
}

export default FishSearchForm
